import React, { useState, useEffect, useRef } from "react";
import Grid from "@material-ui/core/Grid";
import Button from "../Button"
import ReactTable from "react-table";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import ListSubheader from "@material-ui/core/ListSubheader";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import { KeyboardDatePicker } from "@material-ui/pickers";
import StatusOverlay from "../StatusOverlay";
import CheckBox from "@material-ui/core/Checkbox";
import moment from "moment";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from '@material-ui/core/IconButton';
import { Chip, Box } from '@material-ui/core';

const Create = ({ openDialog, setOpenDialog, counties, doFetchCreateWeatherMoratorium }) => {
  const defaultForm = {
    tdsp_id: null,
    counties: [],
    start_date: null,
    end_date: null,
  }
  const localtz = moment.tz.guess()
  const [form, setForm] = useState(defaultForm)
  const [countyTdsp, setCountyTdsp] = useState([])
  const [errorMessage, setErrorMessage] = useState(null)
  const [open, setOpen] = useState(false)

  const isFormComplete = Object.values(form).every(
    (value) => value !== null && value !== undefined && value !== "" && (!Array.isArray(value) || value.length > 0)
  );

  const handleSelect = (e, type) => {
    if (e.target.value) setForm({ ...form, [type]: e.target.value, counties: [] });
    else setForm({ ...form, [type]: null, counties: [] });
  };

  const handleMultiSelect = (e, type) => {
    const { value } = e.target;
    setForm({ ...form, [type]: value });
  };

  const handlePicker = (e, type) => {
    if (e) setForm({ ...form, [type]: e });
    else setForm({ ...form, [type]: null });
  };

  const handleCreate = (e) => {
    if (isFormComplete) {
      e.preventDefault()
      setErrorMessage(null)
      doFetchCreateWeatherMoratorium(form)
      setOpenDialog(false)
    } else {
      setErrorMessage('Complete all required inputs to create a Weather Moratorium record')
    }
  }

  useEffect(() => {
    setForm(defaultForm)
  }, [openDialog])

  return (
    <Dialog
      open={openDialog}
      ariaHideApp={false}
      fullWidth={true}
      maxWidth={"md"}
    >
      <DialogTitle>
        Create Weather Moratorium
      </DialogTitle>
      <DialogContent style={{ overflow: "hidden" }}>
        <DialogContentText>
          <Grid container>
            <Grid item md={12} style={{ marginBottom: "20px" }}>
              <InputLabel>TDSP</InputLabel>
              <Select
                value={form.tdsp_id}
                onChange={(e) => {
                  handleSelect(e, "tdsp_id")
                  setCountyTdsp(counties.filter(x => x.tdsp_id === e.target.value)[0].counties)
                }}
                style={{ width: "100%" }}
              >
                {counties && counties.map(x => <MenuItem key={x.tdsp_id} value={x.tdsp_id}>{x.tdsp_name}</MenuItem>)}
              </Select>
            </Grid>
            <Grid item md={12} style={{ marginBottom: "20px" }}>
              <InputLabel>Counties</InputLabel>
              <Select
                multiple
                value={form.counties || []}
                onChange={(e) => handleMultiSelect(e, "counties")}
                style={{ width: "100%" }}
                renderValue={(selected) => selected.join(", ")}
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                MenuProps={{
                  disableAutoFocusItem: true,
                  onClose: () => setOpen(false),
                }}
              >
                <ListSubheader style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: "black",
                  color: "white",
                  marginTop: "-10px",
                }}
                >
                  <span>Select counties</span>
                  <IconButton size="small" style={{ color: 'white' }} onClick={(e) => {
                    e.stopPropagation()
                    setOpen(false)
                  }}>
                    <CloseIcon />
                  </IconButton>
                </ListSubheader>

                {counties &&
                  countyTdsp &&
                  countyTdsp.map((x) => (
                    <MenuItem key={x} value={x}>
                      <CheckBox checked={form.counties?.includes(x) || false} />
                      {x}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item md={12} style={{ marginBottom: "20px" }}>
              <InputLabel>Start Date</InputLabel>
              <KeyboardDatePicker
                onChange={(e) => handlePicker(moment(e).format("YYYY-MM-DD"), "start_date")}
                format="yyyy-MM-dd"
                value={
                  form.start_date
                    ? moment(form.start_date).tz(localtz)
                    : null
                }
                views={["year", "month", "date"]}
                style={{ width: "100%" }}
                disablePast
              />
            </Grid>
            <Grid item md={12}>
              <InputLabel>End Date</InputLabel>
              <KeyboardDatePicker
                onChange={(e) => handlePicker(moment(e).format("YYYY-MM-DD"), "end_date")}
                format="yyyy-MM-dd"
                value={
                  form.end_date
                    ? moment(form.end_date).tz(localtz)
                    : null
                }
                views={["year", "month", "date"]}
                style={{ width: "100%" }}
                minDate={form.start_date ? moment(form.start_date).tz(localtz) : moment().startOf("day")}
              />
            </Grid>
            {
              errorMessage && (
                <Grid item md={12}>
                  <div style={{ color: 'red', marginTop: '20px' }}>{errorMessage}</div>
                </Grid>
              )
            }
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={e => {
            handleCreate(e)
          }}
          color="secondary"
          variant="contained"
          disabled={!isFormComplete}
          style={{
            float: "right",
            marginRight: 20,
            marginBottom: 10,
          }}
        >
          Create
        </Button>
        <Button
          onClick={() => {
            setForm(defaultForm)
            setOpenDialog(false)
          }}
          color="primary"
          variant="contained"
          style={{
            float: "right",
            marginRight: 20,
            marginBottom: 10,
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const Update = ({ openDialog, setOpenDialog, counties, doFetchUpdateWeatherMoratorium, weatherMoratorium }) => {
  const localtz = moment.tz.guess()
  const [form, setForm] = useState({})
  const [countyTdsp, setCountyTdsp] = useState([])
  const [errorMessage, setErrorMessage] = useState(null)
  const [open, setOpen] = useState(false)

  const isFormComplete = Object.values(form).every(
    (value) => value !== null && value !== undefined && value !== "" && (!Array.isArray(value) || value.length > 0)
  );

  const handleMultiSelect = (e, type) => {
    const { value } = e.target;
    setForm({ ...form, [type]: value.length > 0 ? value : null });
  };

  const handlePicker = (e, type) => {
    if (e) setForm({ ...form, [type]: moment(e).format("YYYY-MM-DD") });
    else setForm({ ...form, [type]: null });
  };

  const handleCreate = (e) => {
    if (isFormComplete) {
      e.preventDefault()
      setErrorMessage(null)
      doFetchUpdateWeatherMoratorium({
        ...form,
        id: weatherMoratorium.id
      })
      setOpenDialog(false)
    } else {
      setErrorMessage('Complete all required inputs to create a Weather Moratorium record')
    }
  }

  useEffect(() => {
    if (weatherMoratorium) {
      setForm({
        counties: weatherMoratorium.counties,
        end_date: weatherMoratorium.end_date ? weatherMoratorium.end_date.split('T')[0] : null,
      })
      let countyList = counties.filter(x => x.tdsp_name === weatherMoratorium.tdsp_name)
      if (countyList.length > 0) {
        setCountyTdsp(countyList[0].counties)
      }
    }
  }, [weatherMoratorium])

  return (
    <Dialog
      open={openDialog}
      ariaHideApp={false}
      fullWidth={true}
      maxWidth={"md"}
    >
      <DialogTitle>
        Update Weather Moratorium
      </DialogTitle>
      <DialogContent style={{ overflow: "hidden" }}>
        <DialogContentText>
          <Grid container>
            <Grid item md={12} style={{ marginBottom: "20px" }}>
              <InputLabel>Counties</InputLabel>
              <Select
                multiple
                value={form.counties || []}
                onChange={(e) => handleMultiSelect(e, "counties")}
                style={{ width: "100%" }}
                renderValue={(selected) => selected.join(", ")}
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                MenuProps={{
                  disableAutoFocusItem: true,
                  onClose: () => setOpen(false),
                }}
              >
                <ListSubheader style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: "black",
                  color: "white",
                  marginTop: "-10px",
                }}
                >
                  <span>Select counties</span>
                  <IconButton size="small" style={{ color: 'white' }} onClick={(e) => {
                    e.stopPropagation()
                    setOpen(false)
                  }}>
                    <CloseIcon />
                  </IconButton>
                </ListSubheader>

                {counties &&
                  countyTdsp &&
                  countyTdsp.map((x) => (
                    <MenuItem key={x} value={x}>
                      <CheckBox checked={form.counties?.includes(x) || false} />
                      {x}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item md={12}>
              <InputLabel>End Date</InputLabel>
              <KeyboardDatePicker
                onChange={(e) => handlePicker(moment(e).format("YYYY-MM-DD"), "end_date")}
                format="yyyy-MM-dd"
                value={
                  form.end_date
                    ? moment(form.end_date).tz(localtz)
                    : null
                }
                views={["year", "month", "date"]}
                style={{ width: "100%" }}
                minDate={
                  moment.max(
                    moment().startOf("day"),
                    weatherMoratorium && weatherMoratorium.start_date
                      ? moment(weatherMoratorium.start_date).tz(localtz)
                      : moment().startOf("day")
                  )
                }
              />
            </Grid>
            {
              errorMessage && (
                <Grid item md={12}>
                  <div style={{ color: 'red', marginTop: '20px' }}>{errorMessage}</div>
                </Grid>
              )
            }
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={e => {
            handleCreate(e)
          }}
          color="secondary"
          variant="contained"
          disabled={!isFormComplete}
          style={{
            float: "right",
            marginRight: 20,
            marginBottom: 10,
          }}
        >
          Update
        </Button>
        <Button
          onClick={() => {
            setOpenDialog(false)
          }}
          color="primary"
          variant="contained"
          style={{
            float: "right",
            marginRight: 20,
            marginBottom: 10,
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const WeatherMoratorium = props => {
  const {
    counties,
    weatherMoratorium,
    doFetchGetTDSPCounties,
    doFetchWeatherMoratorium,
    doFetchCreateWeatherMoratorium,
    doFetchUpdateWeatherMoratorium
  } = props
  const [openDialog, setOpenDialog] = useState(false)
  const [openEditDialog, setOpenEditDialog] = useState(false)
  const [selectedWeatherMoratorium, setSelectedWeatherMoratorium] = useState(null)
  const [weatherMoratoriumList, setWeatherMoratoriumList] = useState([])
  const [status, setStatus] = useState('all')

  const columns = [
    {
      Header: "TDSP",
      accessor: "tdsp_name",
      Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>{value}</div>)
    },
    {
      Header: "Counties",
      accessor: "counties",
      Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>
        <Box display="flex" flexWrap="wrap" gap={0.5}>
          {value.map((tag, index) => (
            <Chip
              key={index}
              label={tag}
              size="small"
              style={{ margin: '1px' }}
              sx={{ fontSize: '0.75rem', height: 22, padding: '0 6px' }}
              color="primary"
            />
          ))}
        </Box>
      </div>)
    },
    {
      Header: "Start Date",
      accessor: "start_date",
      Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>{value.split("T")[0]}</div>),
    },
    {
      Header: "End Date",
      accessor: "end_date",
      Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>{value.split("T")[0]}</div>),
    },
    {
      Header: "",
      accessor: "id",
      width: 100,
      Cell: (i) => (
        <Button
          onClick={async () => {
            setSelectedWeatherMoratorium(i.row)
            setOpenEditDialog(true)
          }}
          variant="contained"
          color="secondary"
        >
          Edit
        </Button>
      )
    }
  ]

  useEffect(() => {
    doFetchGetTDSPCounties()
    doFetchWeatherMoratorium()
  }, [])

  useEffect(() => {
    if (status === 'all') {
      setWeatherMoratoriumList(weatherMoratorium)
    } else if (status === 'active') {
      setWeatherMoratoriumList(weatherMoratorium.filter(x => x.is_active))
    } else {
      setWeatherMoratoriumList(weatherMoratorium.filter(x => !x.is_active || x.is_active === undefined))
    }
  }, [status, weatherMoratorium])

  return (
    <div>
      <StatusOverlay />
      <Grid container>
        <Grid item sm={12}>
          <h4>Weather Moratorium</h4>
        </Grid>
        <Grid item sm={3}>
          <Select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            style={{ width: "100%" }}
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="active">Active</MenuItem>
            <MenuItem value="inactive">Inactive</MenuItem>
          </Select>
        </Grid>
        <Grid item sm={4}>
          <Button
            color="secondary"
            variant="contained"
            onClick={() => setOpenDialog(true)}
            style={{ marginBottom: "5px", marginLeft: "20px" }}
          >
            Create
          </Button>
          <Create
            counties={counties}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            doFetchCreateWeatherMoratorium={doFetchCreateWeatherMoratorium}
          />
          <Update
            counties={counties}
            openDialog={openEditDialog}
            setOpenDialog={setOpenEditDialog}
            weatherMoratorium={selectedWeatherMoratorium}
            doFetchUpdateWeatherMoratorium={doFetchUpdateWeatherMoratorium}
          />
        </Grid>
      </Grid>
      <br />
      {
        weatherMoratoriumList && weatherMoratoriumList.length > 0 ? (
          <ReactTable
            data={weatherMoratoriumList}
            columns={columns}
            className="-striped -highlight"
            defaultPageSize={10}
            defaultSortDesc
            filterable
          />
        ) : (
          <div>
            There are no weather moratorium to show
          </div>
        )

      }
    </div>
  )
}

export default WeatherMoratorium